const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

// `2026-10-25` → полночь этого дня по местному времени. Несуществующая дата (`2026-02-30`) — `null`.
export const parseIsoDay = (value: string): Date | null => {
  const match = ISO_DAY.exec(value);
  if (match === null) {
    return null;
  }
  const [year, month, day] = [Number(match[1]), Number(match[2]) - 1, Number(match[3])];
  const date = new Date(year, month, day);
  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day
    ? date
    : null;
};
